import ExternalLink from './ExternalLink'
export { ExternalLink }
export default ExternalLink
